import { render, staticRenderFns } from "./DeclarePerformanceHours.vue?vue&type=template&id=6c4d07f5&scoped=true"
import script from "./DeclarePerformanceHours.vue?vue&type=script&lang=js"
export * from "./DeclarePerformanceHours.vue?vue&type=script&lang=js"
import style0 from "./DeclarePerformanceHours.vue?vue&type=style&index=0&id=6c4d07f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4d07f5",
  null
  
)

export default component.exports